export const scoreFilterOption = [
  { value: "50", label: "≥ 5.0" },
  { value: "60", label: "≥ 6.0" },
  { value: "70", label: "≥ 7.0" },
  { value: "80", label: "≥ 8.0" },
  { value: "90", label: "≥ 9.0" },
];
